<template>
<div class="fix-tables">
  <div class="table-scroll-container" ref="tbl">
    <slot id="slot1"></slot>
  </div>
  <div class="fixed-wrap" :class="{ nodata: !data || data.length === 0 }" :style="`width:${fixedWidth}px`" ref="tbl2">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      fixedWidth: 0,
    }
  },
  mounted() {
    window.onresize = () => {
      this.$nextTick(this.relayout)
    }
  },
  watch: {
    data() {
      this.$nextTick(this.relayout)
    },
  },
  methods: {
    relayout() {
      var width = this.$refs.tbl.querySelector('div:first-child').offsetWidth
      this.$refs.tbl2.querySelector('div:first-child').style.width =
        width + 'px'
      console.log('firstdiv:', width)
      var totalWidth = 0
      var cols = this.$refs.tbl.querySelectorAll('.fixed')
      var checkbox = this.$refs.tbl.querySelector('th:first-child')
      console.log(cols)
      for (var i = 0; i < cols.length; i++) {
        totalWidth += cols[i].offsetWidth
      }
      this.fixedWidth = totalWidth + checkbox.offsetWidth
      console.log(this.fixedWidth)
    },
  },
}
</script>

<style>
.fix-tables {
  position: relative;
}

.fix-tables .nodata {
  display: none;
}

.fix-tables .fixed-wrap {
  position: absolute;
  left: 0px;
  top: 0px;
  background: #fff;
  box-shadow: 0 0 10px rgb(0 0 0 /12%);
}

.fix-tables .table-scroll-container {
  overflow: auto;
  overflow-x: auto;
  width: 100%;
}

.fix-tables .fixed-wrap .v-datatable__actions {
  display: none;
}

.fix-tables .fixed-wrap {
  overflow-x: hidden;
}

.fix-tables .fixed-wrap .v-table__overflow {
  overflow-x: hidden;
  /* position: absolute; */
  /* top: 0;
  left: 0; */
  /* z-index: 2;
  border-collapse: collapse;
  text-align: left; */
}

/* .fix-tables table.v-datatable {
  table-layout: fixed;
} */
</style>
